// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  BASE_URL: "/geoportal/api",
  RESOURCES: {
    LOGIN: "/loginServlet"
  },
  COOKIES: {
    TEXT_LEGAL: {
      NOM: 'stl',
      DIES: 7
    }
  },
  HABILITA_MODAL_TEXT_LEGAL: false,
};



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/environments/environment.ts